import { ActivityType } from 'types/interfaces/activity';
import {
  faHeart,
  faArrowUp,
  faPlus,
  faArrowDown,
  faTruck,
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface ActivityTypeConfig {
  label: string;
  color: string;
  bgColor: string;
  borderColor: string;
  icon: IconDefinition;
}

export const ACTIVITY_TYPE_CONFIG: Record<ActivityType, ActivityTypeConfig> = {
  want_added: {
    label: 'Wanted',
    color: '#E02CDC',
    bgColor: 'rgba(224, 44, 220, 0.12)',
    borderColor: 'rgba(224, 44, 220, 0.40)',
    icon: faHeart,
  },
  trade_sent: {
    label: 'Sent',
    color: '#DD5BEA',
    bgColor: 'rgba(221, 91, 234, 0.12)',
    borderColor: 'rgba(221, 91, 234, 0.40)',
    icon: faArrowUp,
  },
  card_added: {
    label: 'Added',
    color: '#C769EB',
    bgColor: 'rgba(199, 105, 235, 0.12)',
    borderColor: 'rgba(199, 105, 235, 0.40)',
    icon: faPlus,
  },
  trade_shipped: {
    label: 'Shipped',
    color: '#8D37A7',
    bgColor: 'rgba(141, 55, 167, 0.12)',
    borderColor: 'rgba(141, 55, 167, 0.40)',
    icon: faTruck,
  },
  trade_received: {
    label: 'Received',
    color: '#8409D3',
    bgColor: 'rgba(132, 9, 211, 0.12)',
    borderColor: 'rgba(132, 9, 211, 0.40)',
    icon: faArrowDown,
  },
};

export const ALL_ACTIVITY_TYPES: ActivityType[] = [
  'want_added',
  'trade_sent',
  'card_added',
  'trade_shipped',
  'trade_received',
];
